export const currencyTypes = {
    USD: "USD",
    EUR: "EUR",
    INR: "INR",
    GBP: "GBP",
};

export const currencyDispayTypes = {
    CODE: "code",
    SYMBOL: "symbol",
}